import { FC, useState, KeyboardEvent, ChangeEvent } from 'react';
import { Send } from 'lucide-react';
import { useAutoResizeTextarea } from '../../hooks/useAutoResizeTextarea';

interface ChatMessageInputProps {
  onSend: (text: string) => void;
  disabled?: boolean;
}

export const ChatMessageInput: FC<ChatMessageInputProps> = ({ onSend, disabled = false }) => {
  const [text, setText] = useState('');
  const { textareaRef, minHeight, maxHeight } = useAutoResizeTextarea(text);

  const handleSend = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSend(trimmed);
    setText('');
  };

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="border-2 border-(--neutral-black-NB100) p-3 flex justify-between gap-4">
      <div className="flex items-center w-full border-2 border-(--neutral-white-NW800) rounded-[8px] p-2">
        <textarea
          ref={textareaRef}
          id="message"
          name="message"
          value={text}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="Type a message..."
          disabled={disabled}
          rows={1}
          className="w-full overflow-y-auto resize-none! bg-transparent border-none outline-none text-(--neutral-black-NB1000) placeholder:text-(--neutral-black-NB400) leading-[20px] py-[10px]"
          style={{ minHeight, maxHeight }}
        />
        {/* TODO: Implement attachments and emojis later */}
        {/* <div className="flex gap-2">
          <button
            type="button"
            className="flex-shrink-0 p-1 text-(--neutral-black-NB500) hover:text-(--neutral-black-NB800) transition-colors cursor-pointer"
            title="Attach file"
          >
            <Paperclip size={20} />
          </button>

          <button
            type="button"
            className="flex-shrink-0 p-1 text-(--neutral-black-NB500) hover:text-(--neutral-black-NB800) transition-colors cursor-pointer"
            title="Emoji"
          >
            <Smile size={20} />
          </button>
        </div> */}
      </div>
      <button
        type="button"
        onClick={handleSend}
        disabled={disabled || !text.trim()}
        className="w-[56px] h-[56px] flex justify-center items-center flex-shrink-0 p-2 bg-(--primary-O900) text-white rounded-full! hover:opacity-90 transition-opacity disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        title="Send message"
      >
        <Send size={24} color="white" />
      </button>
    </div>
  );
};
